!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@material-ui/core"), require("@material-ui/icons/FormatBold"), require("@material-ui/icons/FormatListBulleted"), require("@material-ui/icons/FormatListNumbered"), require("@material-ui/icons/FormatItalic"), require("@material-ui/icons/FormatUnderlined"), require("@material-ui/icons/SpaceBar"), require("@material-ui/icons/StrikethroughS"), require("@material-ui/icons/LooksOne"), require("@material-ui/icons/LooksTwo"), require("@material-ui/icons/Looks3"), require("classnames"), require("formik"), require("draft-js"), require("react"), require("@campfire/titular-tooltip"), require("@campfire/hover-link/lib"), require("@material-ui/icons/Link"), require("@material-ui/icons/OpenInNew"), require("@material-ui/icons/Edit")) : "function" == typeof define && define.amd ? define(["exports", "@material-ui/core", "@material-ui/icons/FormatBold", "@material-ui/icons/FormatListBulleted", "@material-ui/icons/FormatListNumbered", "@material-ui/icons/FormatItalic", "@material-ui/icons/FormatUnderlined", "@material-ui/icons/SpaceBar", "@material-ui/icons/StrikethroughS", "@material-ui/icons/LooksOne", "@material-ui/icons/LooksTwo", "@material-ui/icons/Looks3", "classnames", "formik", "draft-js", "react", "@campfire/titular-tooltip", "@campfire/hover-link/lib", "@material-ui/icons/Link", "@material-ui/icons/OpenInNew", "@material-ui/icons/Edit"], t) : t((e = e || self)["campfire-rich-editor"] = {}, e.core, e.FormatBold, e.FormatListBulleted, e.FormatListNumbered, e.FormatItalic, e.FormatUnderlined, e.SpaceBar, e.StrikethroughS, e.LooksOne, e.LooksTwo, e.Looks3, e.classNames, e.formik, e.draftJs, e.React, e.titularTooltip, e.lib, e.LinkIcon, e.OpenInNewIcon, e.EditIcon);
}(this, function (e, t, r, o, n, a, i, l, c, u, s, d, m, p, f, y, g, h, b, E, S) {
  "use strict";

  r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r, o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o, n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n, a = a && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a, i = i && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i, l = l && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l, c = c && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c, u = u && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u, s = s && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s, d = d && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d, m = m && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m;
  var k = "default" in y ? y.default : y;
  b = b && Object.prototype.hasOwnProperty.call(b, "default") ? b.default : b, E = E && Object.prototype.hasOwnProperty.call(E, "default") ? E.default : E, S = S && Object.prototype.hasOwnProperty.call(S, "default") ? S.default : S;

  var _v = function v() {
    return (_v = Object.assign || function (e) {
      for (var t, r = 1, o = arguments.length; r < o; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);

      return e;
    }).apply(this, arguments);
  },
      C = function C(e) {
    var r = e.onClick,
        o = e.label,
        n = e.active,
        a = e.Icon;
    return k.createElement(g.TitularTooltip, {
      enterDelay: 400,
      description: o,
      placement: "top"
    }, k.createElement(t.IconButton, {
      size: "small",
      onMouseDown: r
    }, k.createElement(a, {
      fontSize: "small",
      style: n ? {
        color: "#2196f3"
      } : void 0
    }, o)));
  };

  function w(e) {
    switch (e.getType()) {
      case "blockquote":
        return "RichEditor-blockquote";

      default:
        return "";
    }
  }

  var L = function L(e) {
    var t = e.onToggle,
        r = e.style,
        o = e.label,
        n = e.active,
        a = e.Icon;
    return k.createElement(C, {
      onClick: function onClick(e) {
        e.preventDefault(), t(r);
      },
      active: n,
      Icon: a,
      label: o
    });
  },
      O = function O(e) {
    var t = e.onToggle,
        r = e.editorState,
        o = e.styles,
        n = r.getSelection(),
        a = r.getCurrentContent().getBlockForKey(n.getStartKey()).getType();
    return k.createElement(k.Fragment, null, o.map(function (e) {
      return k.createElement(L, {
        key: e.label,
        active: e.style === a,
        label: e.label,
        onToggle: t,
        style: e.style,
        Icon: e.icon
      });
    }));
  },
      x = function x(e) {
    var t = e.onToggle,
        r = e.editorState,
        o = e.styles,
        n = r.getCurrentInlineStyle();
    return k.createElement(k.Fragment, null, o.map(function (e) {
      return k.createElement(L, {
        key: e.label,
        active: n.has(e.style),
        label: e.label,
        onToggle: t,
        style: e.style,
        Icon: e.icon
      });
    }));
  },
      T = t.withStyles(function () {
    return {
      tooltip: {
        backgroundColor: "#ffffff",
        color: "#242424",
        padding: 0,
        width: 360,
        fontSize: 15,
        boxShadow: "0 2px 10px 0 rgba(21, 27, 38, 0.1)",
        borderRadius: 4,
        border: "solid 1px #e9e9e9"
      }
    };
  })(t.Tooltip),
      D = function D(e) {
    var r = e.contentState,
        o = e.entityKey,
        n = e.openLinkDialog,
        a = e.children,
        i = r.getEntity(o).getData().url;
    return k.createElement(T, {
      placement: "top",
      title: k.createElement(k.Fragment, null, k.createElement(t.Box, {
        style: {
          boxSizing: "border-box"
        },
        width: 1,
        height: 1,
        padding: 2,
        paddingLeft: 3
      }, k.createElement(t.Box, {
        width: 1,
        display: "flex",
        justifyContent: "flex-end"
      }, k.createElement(h.HoverText, {
        variant: "body2",
        color: "primary",
        onClick: function onClick() {
          return n(i, o);
        },
        gutterBottom: !0
      }, "Edit link", k.createElement(S, {
        style: {
          marginLeft: 4,
          marginBottom: -4
        },
        fontSize: "small"
      }))), k.createElement(h.HoverLink, {
        target: "_blank",
        rel: "noopener",
        to: i,
        external: !0,
        color: "textSecondary",
        hoverColor: "textSecondary"
      }, k.createElement(t.Typography, {
        display: "inline",
        variant: "body2",
        style: {
          wordBreak: "break-all",
          display: "block"
        }
      }, k.createElement(E, {
        style: {
          fontSize: 14,
          marginRight: 8,
          marginBottom: -2
        }
      }), i)))),
      enterDelay: 175,
      leaveDelay: 225,
      interactive: !0
    }, k.createElement("span", null, k.createElement(h.HoverLink, {
      to: i,
      external: !0,
      target: "_blank",
      rel: "noopener",
      color: "primary",
      hoverColor: "primary"
    }, a)));
  },
      B = function B(e) {
    var t = e.openLinkDialogWithUrl;
    return new f.CompositeDecorator([{
      strategy: I,
      component: D,
      props: {
        openLinkDialog: t
      }
    }]);
  };

  function I(e, t, r) {
    e.findEntityRanges(function (e) {
      var t = e.getEntity();
      return null !== t && "LINK" === r.getEntity(t).getType();
    }, t);
  }

  var F = function F(e) {
    var r = e.open,
        o = e.close,
        n = e.setLinkState,
        a = e.value,
        i = k.createRef();
    return y.useEffect(function () {
      i.current && i.current.focus();
    }, [i]), k.createElement(t.Dialog, {
      open: r,
      onBackdropClick: o,
      fullWidth: !0,
      maxWidth: "sm"
    }, k.createElement(t.DialogContent, {
      style: {
        padding: 8
      }
    }, k.createElement("form", {
      onSubmit: function onSubmit(e) {
        e.preventDefault(), e.stopPropagation(), o();
      }
    }, k.createElement(t.TextField, {
      fullWidth: !0,
      placeholder: "Add URL",
      inputRef: i,
      variant: "outlined",
      value: a,
      onChange: function onChange(e) {
        e.persist(), n(function (t) {
          return _v(_v({}, t), {
            urlValue: e.target.value
          });
        });
      }
    }))));
  },
      j = function j(e) {
    var t = e.editorState,
        r = e.setEditorState,
        o = y.useState({
      showLinkDialog: !1,
      urlValue: "",
      entityKey: ""
    }),
        n = o[0],
        a = o[1];

    function i() {
      var e = n.urlValue,
          r = t.getCurrentContent();

      if (n.entityKey) {
        var o = n.entityKey,
            i = f.EditorState.set(t, {
          currentContent: r.replaceEntityData(n.entityKey, {
            url: e
          }),
          decorator: B({
            openLinkDialogWithUrl: function openLinkDialogWithUrl(e, t) {
              a({
                showLinkDialog: !0,
                urlValue: e,
                entityKey: t
              });
            }
          })
        });
        return f.RichUtils.toggleLink(i, i.getSelection(), o);
      }

      var l = r.createEntity("LINK", "MUTABLE", {
        url: e
      }),
          c = l.getLastCreatedEntityKey(),
          u = f.EditorState.set(t, {
        currentContent: l,
        decorator: B({
          openLinkDialogWithUrl: function openLinkDialogWithUrl(e, t) {
            a({
              showLinkDialog: !0,
              urlValue: e,
              entityKey: t
            });
          }
        })
      });
      return f.RichUtils.toggleLink(u, u.getSelection(), c);
    }

    return y.useEffect(function () {
      r(i());
    }, []), k.createElement(k.Fragment, null, k.createElement(F, {
      open: n.showLinkDialog,
      close: function close() {
        return r(i()), void a({
          showLinkDialog: !1,
          urlValue: "",
          entityKey: ""
        });
      },
      setLinkState: a,
      value: n.urlValue
    }), k.createElement(C, {
      onClick: function onClick() {
        if (!t.getSelection().isCollapsed()) {
          var e = t.getCurrentContent(),
              r = t.getSelection().getStartKey(),
              o = t.getSelection().getStartOffset(),
              n = e.getBlockForKey(r).getEntityAt(o);

          if (n) {
            var i = e.getEntity(n);
            a({
              showLinkDialog: !0,
              urlValue: i.getData().url,
              entityKey: n
            });
          }

          a(function (e) {
            return _v(_v({}, e), {
              showLinkDialog: !0
            });
          });
        }
      },
      label: "Insert link",
      active: !1,
      Icon: b
    }));
  },
      R = new f.CompositeDecorator([{
    strategy: I,
    component: function component(e) {
      var t = e.contentState,
          r = e.entityKey,
          o = e.children,
          n = t.getEntity(r).getData().url;
      return k.createElement(g.TitularTooltip, {
        description: n,
        enterDelay: 175
      }, k.createElement("span", null, k.createElement(h.HoverLink, {
        target: "_blank",
        rel: "noopener",
        to: n,
        external: !0,
        color: "primary",
        hoverColor: "primary"
      }, o)));
    }
  }]);

  var U = {
    STRIKETHROUGH: {
      textDecoration: "line-through"
    }
  },
      N = [{
    label: "Bulleted List",
    icon: o,
    style: "unordered-list-item"
  }, {
    label: "Numbered List",
    icon: n,
    style: "ordered-list-item"
  }],
      K = [{
    label: "Bold",
    icon: r,
    style: "BOLD"
  }, {
    label: "Italic",
    icon: a,
    style: "ITALIC"
  }, {
    label: "Underline",
    icon: i,
    style: "UNDERLINE"
  }, {
    label: "Strikethrough",
    icon: c,
    style: "STRIKETHROUGH"
  }, {
    label: "Monospace",
    icon: l,
    style: "CODE"
  }],
      q = [{
    label: "Heading 1",
    icon: u,
    style: "header-one"
  }, {
    label: "Heading 2",
    icon: s,
    style: "header-two"
  }, {
    label: "Heading 3",
    icon: d,
    style: "header-three"
  }],
      P = function P(e) {
    var r,
        o,
        n = e.initialState,
        a = e.editorState,
        i = e.setEditorState,
        l = e.children,
        c = e.render,
        u = e.placeholder,
        s = y.useState(!1),
        d = s[0],
        p = s[1],
        g = y.useState(!1),
        h = g[0],
        b = g[1],
        E = y.useRef(null),
        S = y.useMemo(function () {
      var e = a.getCurrentContent();
      return !e.hasText() && "unstyled" !== e.getBlockMap().first().getType();
    }, [a.getCurrentContent()]),
        v = y.useCallback(i || function () {}, [i]);

    function C(e) {
      d || e.getCurrentContent() === a.getCurrentContent() || p(!0), !d || n || e.getCurrentContent().hasText() || p(!1), v(e);
    }

    function L(e) {
      C(f.RichUtils.toggleBlockType(a, e));
    }

    var T = z();
    return k.createElement("div", {
      className: m(T.container, (r = {}, r[T.containerFocused] = h, r[T.readOnly] = !i, r))
    }, k.createElement("div", {
      onClick: function onClick() {
        i && E && E.current && (E.current.focus(), b(!0));
      },
      className: m(T.root, (o = {}, o[T.rootNoPadding] = !i, o))
    }, k.createElement(f.Editor, {
      onBlur: function onBlur() {
        E && E.current && (E.current.blur(), b(!1)), C(n || f.EditorState.createEmpty()), p(!1);
      },
      blockStyleFn: w,
      customStyleMap: U,
      handleKeyCommand: function handleKeyCommand(e, t) {
        var r = f.RichUtils.handleKeyCommand(t, e);
        return r ? (C(r), "handled") : "not-handled";
      },
      placeholder: S ? void 0 : u,
      editorState: a,
      onChange: C,
      ref: E,
      spellCheck: !0,
      readOnly: !i
    })), i ? k.createElement(t.Grid, {
      container: !0,
      className: T.controlsContainer,
      justify: "space-between",
      alignContent: "flex-start",
      alignItems: "flex-start"
    }, k.createElement(t.Grid, {
      item: !0
    }, k.createElement(t.Box, {
      display: "flex",
      flexWrap: "wrap"
    }, k.createElement(x, {
      editorState: a,
      onToggle: function onToggle(e) {
        C(f.RichUtils.toggleInlineStyle(a, e));
      },
      styles: K
    }), k.createElement(j, {
      editorState: a,
      setEditorState: i
    }), k.createElement(t.Box, {
      height: "auto",
      width: "1px",
      bgcolor: "#e9e9e9",
      marginX: 2
    }), k.createElement(O, {
      editorState: a,
      onToggle: L,
      styles: q
    }), k.createElement(t.Box, {
      height: "auto",
      width: "1px",
      bgcolor: "#e9e9e9",
      marginX: 2
    }), k.createElement(O, {
      editorState: a,
      onToggle: L,
      styles: N
    }))), k.createElement(t.Grid, {
      xs: !0,
      item: !0,
      container: !0,
      justify: "flex-end",
      wrap: "nowrap"
    }, c && c({
      hasChanges: d
    }), l && l({
      hasChanges: d
    }))) : null);
  },
      H = function H(e) {
    var t = e.editorState,
        r = W(),
        o = function (e) {
      var t = e.getCurrentContent().createEntity("LINK", "MUTABLE"),
          r = t.getLastCreatedEntityKey(),
          o = f.EditorState.set(e, {
        currentContent: t,
        decorator: R
      });
      return f.RichUtils.toggleLink(o, o.getSelection(), r);
    }(t);

    return k.createElement("div", {
      className: r.root
    }, k.createElement(f.Editor, {
      onChange: function onChange() {},
      editorState: o,
      readOnly: !0
    }));
  },
      M = function M(e) {
    var t = e.setEditorState,
        r = e.readOnly;
    return t && !r ? k.createElement(P, _v({}, e)) : k.createElement(H, _v({}, e));
  },
      W = t.makeStyles(function () {
    return t.createStyles({
      root: {
        fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(",")
      }
    });
  }),
      z = t.makeStyles(function (e) {
    return t.createStyles({
      container: {
        backgroundColor: "white",
        borderRadius: 4,
        padding: 1,
        border: "solid 1px rgba(0, 0, 0, 0.25)",
        width: "100%",
        boxSizing: "border-box",
        transition: "border-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
        "&:hover": {
          cursor: "text",
          borderColor: "rgba(0, 0, 0, 0.54)",
          "& $controlsContainer": {
            borderColor: "rgba(0, 0, 0, 0.54)"
          }
        }
      },
      containerFocused: {
        padding: 0,
        border: "solid 2px " + e.palette.primary.main,
        "&:hover": {
          cursor: "text",
          borderColor: e.palette.primary.main
        },
        "& $controlsContainer": {
          borderColor: e.palette.primary.main
        }
      },
      root: {
        paddingTop: 12,
        paddingLeft: 9,
        paddingRight: 6,
        paddingBottom: 12,
        "& .public-DraftEditor-content": {
          minHeight: 58
        },
        "& .public-DraftEditorPlaceholder-root": {
          marginBottom: -18,
          color: "rgba(0,0,0,0.3)"
        },
        "& .public-DraftStyleDefault-block": {
          overflowWrap: "break-word",
          wordWrap: "break-word",
          wordBreak: "break-all",
          hyphens: "auto"
        },
        fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(",")
      },
      controlsContainer: {
        borderTop: "solid 1px rgba(0, 0, 0, 0.25)",
        padding: 12
      },
      readOnly: {
        backgroundColor: "rgba(0,0,0,0)",
        padding: 0,
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0)"
        }
      },
      rootNoPadding: {
        "& .public-DraftEditor-content": {
          minHeight: 0
        }
      }
    });
  }),
      A = function A(e) {
    if (!e) return f.EditorState.createEmpty();

    try {
      return f.EditorState.createWithContent(f.convertFromRaw(JSON.parse(e)));
    } catch (e) {
      return f.EditorState.createEmpty();
    }
  };

  e.CampfireRichEditor = M, e.RichEditorFormik = function (e) {
    var t = e.valueName,
        r = void 0 === t ? "editor" : t,
        o = e.placeholder,
        n = p.useFormikContext(),
        a = n.values,
        i = n.setFieldValue,
        l = a[r],
        c = y.useState(function () {
      return A(l);
    }),
        u = c[0],
        s = c[1],
        d = y.useRef(l);
    return y.useEffect(function () {
      l !== d.current && (d.current = l, s(A(l)));
    }, [l]), y.useEffect(function () {
      var e = JSON.stringify(f.convertToRaw(u.getCurrentContent()));
      e !== d.current && (d.current = e, i(r, e));
    }, [u]), k.createElement(M, {
      placeholder: o,
      editorState: u,
      setEditorState: s
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});